import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth-guard';
import { adminGuard } from './core/auth/admin-guard';

import { AppShell } from './layout/app-shell/app-shell';
import { LoginPage } from './features/auth/login/login-page/login-page';
import { ResetPasswordPage } from './features/auth/reset-password/reset-password-page/reset-password-page';
import { DashboardPage } from './features/dashboard/dashboard-page/dashboard-page';
import { MiFichaPage } from './features/mi-ficha/mi-ficha-page/mi-ficha-page';
import { OpportunitiesPage } from './features/opportunities/opportunities-page/opportunities-page';
import { UsersListPage } from './features/users/users-list-page/users-list-page';
import { UsersFormPage } from './features/users/users-form-page/users-form-page';
import { ProfilePage } from './features/profile/profile-page/profile-page';
import { ContactPage } from './features/contact/contact-page/contact-page';
import { OnBoardingPage } from './features/auth/on-boarding/on-boarding-page/on-boarding-page';
import { ProductsListPage } from './features/products/products-list-page/products-list-page';
import { ProductsFormPage } from './features/products/products-form-page/products-form-page';
import { PartnersListPage } from './features/admin/partners/partners-list/partners-list';
import { PartnerDetailPage } from './features/admin/partners/partner-detail/partner-detail';
import { RelationshipTypesListPage } from './features/admin/relationship-types/relationship-types-list/relationship-types-list';

export const routes: Routes = [
  { path: 'login', component: LoginPage },
  { path: 'reset-password', component: ResetPasswordPage },
  { path: 'on-boarding', component: OnBoardingPage },

  {
    path: '',
    component: AppShell,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardPage },
      { path: 'mi-ficha', component: MiFichaPage },
      { path: 'opportunities', component: OpportunitiesPage },
      { path: 'profile', component: ProfilePage },
      { path: 'contact', component: ContactPage },
      {
        path: 'admin',
        canActivate: [adminGuard],
        children: [
          { path: 'users', component: UsersListPage },
          { path: 'users/new', component: UsersFormPage },
          { path: 'users/:id', component: UsersFormPage },
          { path: 'products', component: ProductsListPage },
          { path: 'products/new', component: ProductsFormPage },
          { path: 'products/:id', component: ProductsFormPage },
          {
            path: 'partners',
            component: PartnersListPage,
          },
          {
            path: 'partners/:id',
            component: PartnerDetailPage,
          },
          {
            path: 'relationship-types',
            component: RelationshipTypesListPage,
          },
        ],
      },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    ],
  },

  { path: '**', redirectTo: 'dashboard' },
];
